import { connect } from 'react-redux'
import Login from './components/Login/Login'
import { selectLoginErrorIsInvalid } from '../selectors/login_selectors'
import { createStructuredSelector } from 'reselect'

const mapDispatchToProps = dispatch => ({
    dispatch
})

const mapStateToProps = createStructuredSelector({
  serverError: selectLoginErrorIsInvalid
})

export default connect(mapStateToProps, mapDispatchToProps)(Login)
